import { render } from "./Button.vue?vue&type=template&id=3fb9688b&scoped=true"
const script = {}

import "./Button.vue?vue&type=style&index=0&id=3fb9688b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb9688b"]])

export default __exports__